export default __webpack_public_path__ + "assets/images/cup.e83001.png";